<template>
  <div id="PriceFunFood">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader ||
      loader0 ||
      loader1 ||
      loaderPinList ||
      tableloader ||
      trendLinePincodeLoader ||
      firstTimeTrendLineLoader ||
      downloadExelLoader
      ">
      <!-- <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
      <Loader />
    </div>
    <div class="datepickerwrap card">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="d-flex flex-wrap customWidth-70">
          <div style="min-width: 100px" class="mr-2">
            <div class="mb-1 ml-1" style="font-size: 14px; font-weight: 400; color: #1e1e1e">
              Date
            </div>
            <date-range-picker v-model="dateSingle" :show-dropdowns="true" opens="right" :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }" :single-date-picker="true" :min-date="minDate"
              :max-date="maxDate">
            </date-range-picker>
            <!-- :max-date="maxDate" :min-date="minDate" -->
          </div>
          <div class="customSelect mx-0">
            <div class="mb-1 ml-1" style="font-size: 14px; font-weight: 400; color: #1e1e1e">
              Platform
            </div>
            <select v-model="selectedPlatform" class="form-control text-capitalize" @change="changePlatform">
              <option value="" class="text-capitalize">All Platforms</option>
              <option v-for="(d, i) in platformColor" :value="i" :key="i" class="text-capitalize">
                {{ i.replace("_", " ") }}
              </option>
            </select>
          </div>
          <div class="customSelect mr-0" v-if="isSegment">
            <div class="mb-1 ml-1" style="font-size: 14px; font-weight: 400; color: #1e1e1e">
              Category
            </div>
            <select v-model="segmentDropdown.selectedSegment" class="form-control text-capitalize">
              <option value="" class="text-capitalize">All Categories</option>
              <option v-for="d in segmentDropdown.options" :value="d" :key="d" class="text-capitalize">
                {{ d.replace("_", " ") }}
              </option>
            </select>
          </div>

          <div class="customMultiselect ml-2" style="max-width: 20%" v-if="locationDropdown.options.length">
            <!-- <multiselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options"
                            :multiple="true" group-values="pins" group-label="City" :group-select="true"
                            placeholder="Select PIN(s)" track-by="pin" label="pin" selectGroupLabel="Select group"
                            deselectGroupLabel="Deselect group" selectLabel="Select PIN" deselectLabel="Deselect PIN"
                            @input="processSelectedPin()">
                        </multiselect> -->
            <div class="mb-1 ml-1" style="font-size: 14px; font-weight: 400; color: #1e1e1e">
              Pincode
            </div>
            <treeselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options"
              value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="false" placeholder="Select PIN(s)"
              :multiple="true" :searchable="true">
              <span slot="noResult">Oops! No elements found. Consider changing the search
                query.</span>
            </treeselect>
          </div>

          <div class="d-flex align-items-end mb-1">
            <button @click="filterApply" class="btn primarycolor ml-3">
              Apply Filters
            </button>
          </div>
          <div class="d-lg-none d-flex align-items-center mt-3">
            <div class="d-flex justify-content align-items-center ml-2 competitorCheckBox">
              <div class="form-check form-check-inline">
                <input @change="toggleCompetitorCheckBoxDataValue" class="form-check-input" type="checkbox"
                  id="inlineCheckbox1" :value="competitorCheckBoxDataValue" />
                <label class="form-check-label" for="inlineCheckbox1">Competitor Data</label>
              </div>
            </div>
            <router-link to="/price-tracking-compare">
              <button class="btn compareBtn">Compare</button>
            </router-link>
          </div>
        </div>
        <div class="d-none d-lg-flex justify-content-end align-items-center">
          <!-- <button class="btn insights">
                        insights
                    </button> -->
          <div class="d-flex justify-content align-items-center ml-2 competitorCheckBox">
            <div class="form-check form-check-inline">
              <input @change="toggleCompetitorCheckBoxDataValue" class="form-check-input" type="checkbox"
                id="inlineCheckbox1" :value="competitorCheckBoxDataValue" />
              <label class="form-check-label" for="inlineCheckbox1">Competitor Data</label>
            </div>
          </div>
          <router-link to="/price-tracking-compare">
            <button class="btn compareBtn">Compare</button>
          </router-link>

          <!-- <div class="lastUpdated ml-2">
                        Last Updated: {{ lastUpdated }}
                    </div> -->
        </div>
      </div>
    </div>

    <div class="card p-2 revampCard">
      <!-- price table -->
      <div class="mt-3" v-if="storePriceTableData.data.length">
        <table class="table" v-if="storePriceTableData.data.length" id="price-tracking-table"
          style="width: 100%; overflow: hidden">
          <thead class="thead-normal">
            <tr>
              <th style="padding: 10px 0 !important" scope="col" v-for="th in storePriceTableData.header" :key="th.key"
                class="p-2">
                <img v-if="th.img" :src="th.img" style="width: 19px" />
                {{ th.label }}
              </th>
              <th>TrendLine</th>
            </tr>
          </thead>
          <tbody class="tbody-normal">
            <tr v-for="(row, i) in storePriceTableData.data" :key="i">
              <td v-for="(d, j) in storePriceTableData.header" :key="j" :style="[
                d.key == 'product_name'
                  ? { width: '25%', 'min-width': '240px' }
                  : d.key == 'pincode'
                    ? { width: '6%', 'min-width': '70px' }
                    : d.key == 'flipkart_grocery'
                      ? { width: '11%', 'min-width': '100px' }
                      : { width: '9%', 'min-width': '100px' },
              ]">
                <a :href="row.product_image" target="_blanck" v-if="d.key == 'product_image'"
                  style="display: flex; justify-content: center">
                  <div class="rounded imageContainerPriceTracking" style="
                      width: 100px;
                      text-transform: capitalize;
                      background: linear-gradient(
                        180deg,
                        rgba(0, 0, 0, 0.05) 0%,
                        rgba(255, 255, 255, 0) 100%
                      );
                      border-bottom: 1px solid #ebebeb;
                    ">
                    <img v-if="row[d.key]" :src="row[d.key]" style="
                        width: 100%;
                        mix-blend-mode: multiply;
                        padding: 10px;
                      " />
                    <!-- <img v-else
                                            src="https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                                            style="width: 100%"></img> -->
                    <img v-else src="../../../public/Icons_SVG/noProductImage.svg" style="width: 100%" />
                  </div>
                </a>

                <div v-if="d.key == 'product_name'">
                  <span class="text-capitalize">{{ row[d.key] }}</span>
                </div>
                <div v-if="d.key == 'pincode'">
                  <span class="text-capitalize">{{ row[d.key] }}</span>
                </div>
                <div v-if="d.key == 'mrp'">
                  <span class="text-capitalize" :class="[row[d.key] == 'Out Of Stock' && 'outOfStockColor']">{{
                    row[d.key] }}</span>
                </div>
                <!-- <div v-else>
                                    {{ row[d.key] }}
                                </div> -->
                <div class="d-flex justify-content-center align-items-center">
                  <div v-if="row.platform[d.key]" class="">
                    <div :class="[
                      row.platform[d.key].price === 'Out Of Stock' && 'outOfStockColor',
                    ]">
                      {{ row.platform[d.key].price }}
                    </div>
                    <div class="text-success" v-if="checkPriceDiff(row.platform[d.key].price_diff) == 'up'">
                      <img style="width: 12px; height: 12px; color:green" class="mb-1 mr-1"
                        src="../../../public/Icons_SVG/upPriceArrow.svg" />
                      {{ row.platform[d.key].percentage_change.toFixed(2) }}%
                    </div>
                    <div class="outOfStockColor " v-if="checkPriceDiff(row.platform[d.key].price_diff) == 'down'">
                      <img style="width: 12px; height: 12px;" class="mb-1 mr-1"
                        src="../../../public/Icons_SVG/downPriceArrow.svg" />
                      {{ Math.abs(row.platform[d.key].percentage_change.toFixed(2)) }}%
                    </div>
                  </div>
                </div>
              </td>
              <td style="width: 2%">
                <div @click="
                  processTrendLineModal(
                    row.segment,
                    row.product_name,
                    row.sku,
                    row.pincode
                  )
                  " class="icon showTrandLine">
                  <i class="fa fa-line-chart"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData">
        No Data Available.
      </div>
    </div>

    <!-- trendLine graph -->
    <b-modal size="xl" class="customModal" id="trendLineModal" hide-footer
      style="z-index: 3000 !important; text-transform: capitalize" v-model="showTrendLineModal"
      :title="selectedProductTrendlineModal">
      <!-- <div class="alert alert-danger p-3"  role="alert">
        No Data!!
      </div> -->
      <div class="p-2 w-100" id="#modalContainer" v-if="procedModalTrandLineData.xAxis">
        <div style="display: flex; width: 100%" class="flex-wrap">
          <div class="mr-2 ml-0">
            <div class="mb-1 ml-1" style="
                font-size: 14px;
                font-weight: 400;
                font-family: 'Poppins';
                color: #1e1e1e;
              ">
              Date Range
            </div>
            <date-range-picker v-model="trendlineModalDateRange" opens="right" :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate">
            </date-range-picker>
          </div>
          <!-- <div class="datebox customSeflect">
                        <div class="mb-1 ml-1"
                            style="font-size:14px; font-weight:400; font-family: 'Poppins'; color:#1E1E1E">Platform
                        </div>
                        <select class="form-control text-uppercase" v-model="selectedPlatformTrendlineModal"  multiple>
                            <option v-for="(option, i) in platformColor" :key="i + 'p2'" :value="i">
                                {{ i.replaceAll("_", " ") }}
                            </option>
                        </select>
                    </div> -->
          <!-- <div class="datebox customSeflect">
                        <div class="mb-1 ml-1"
                            style="font-size:14px; font-weight:400; font-family: 'Poppins'; color:#1E1E1E">Platform
                        </div>
                        <select class="form-control text-uppercase" v-model="selectedPlatformTrendlineModal">
                            <option value="">All Platforms</option>
                            <option v-for="(option, i) in platformColor" :key="i + 'p2'" :value="i">
                                {{ i.replaceAll("_", " ") }}
                            </option>
                        </select>
                    </div> -->
          <div class="custom_dropdown customMultiselect" style="width: 15rem">
            <div class="mb-1 ml-1" style="
                font-size: 14px;
                font-weight: 400;
                color: #1e1e1e;
                font-family: 'Poppins';
              ">
              Platforms
            </div>
            <multiselect v-model="selectedPlatformTrendlineModal" :options="storeAllPlatformsListForForMultiSelect"
              :multiple="true" :searchable="false" placeholder="Select Platform" selectLabel="" deselectLabel="Remove"
              :close-on-select="false" @input="changeSelectInput" class="text-capitalize customSelectedLabels">
              <template slot="beforeList">
                <div class="d-flex align-items-center py-2 px-1 allSelect" @click="selectPlatformsForAllList">
                  <input type="checkbox" class="mx-2" v-model="allPlaformSelectedBoolean" />
                  <span class="ml-2">All</span>
                </div>
              </template>
              <template slot="option" slot-scope="{ option }">
                <input type="checkbox" :value="option" v-model="selectedPlatformTrendlineModal" />
                <span class="option__title ml-3 text-capitalize">{{
                  option.replaceAll("_", " ")
                }}</span>
              </template>
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom-tag d-flex align-items-center">
                  {{ option.replaceAll("_", " ") }}
                  <span class="remove-icon ml-0 pl-2 pr-2" @click="remove(option)">×</span>
                </span>
              </template>
            </multiselect>
          </div>
          <div class="datebox customSelect" style="width: 12rem">
            <div class="mb-1 ml-1" style="
                font-size: 14px;
                font-weight: 400;
                font-family: 'Poppins';
                color: #1e1e1e;
              ">
              Category
            </div>
            <select class="form-control text-capitalize" v-model="selectedSegmentTrendlineModal">
              <option value="" class="text-capitalize">All Category</option>
              <option v-for="(d, i) in segmentDropdown.options" :key="d + i + 'sp2'" :value="d" class="text-capitalize">
                {{ d.replaceAll("_", " ") }}
              </option>
            </select>
          </div>
          <!-- <div class="custom_dropdown customMultiselect" style="width:30%">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Product</div>
                        <multiselect v-model="selectedProductTrendlineModal" :options="viewModalProductList"
                            :multiple="false" placeholder="Search Product" select-label="" deselect-label=""
                            selectedLabel="" :closeOnSelect="true" @input="getModalTrendlineGraphData()">
                        </multiselect>
                    </div> -->
          <div class="ml-2 customMultiselect" style="width: 9rem" v-if="viewPinListModalTrendLine">
            <div class="mb-1 ml-1" style="font-size: 14px; font-weight: 400; color: #1e1e1e">
              Pincode
            </div>
            <treeselect v-model="selectedPinTrendLineModal" :options="viewPinListModalTrendLine" :disabled="false"
              value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="true" placeholder="Select PIN(s)"
              :multiple="false" :searchable="true">
              <span slot="noResult">Oops! No elements found. Consider changing the search
                query.</span>
            </treeselect>
          </div>

          <div class="d-flex align-items-end mb-md-1">
            <button :disabled="trendLineGraphLoader" @click="filterApplyForTrendLine"
              class="btn primarycolor d-flex justify-content-center align-items-center ml-3">
              <b-spinner small class="mr-2" v-if="trendLineGraphLoader"></b-spinner>
              <span> Apply Filters</span>
            </button>
          </div>
        </div>
        <div v-if="procedModalTrandLineData.xAxis.length" class="mt-2">
          <lineChart :data="procedModalTrandLineData" />
          <!-- :chartId="selectedSegmentTrendlineModal"  -->
        </div>
        <div v-else class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData mt-3"
          style="font-family: Poppins">
          No Data Available.
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
// import exportingInit from "highcharts/modules/exporting";
// import stockInit from "highcharts/modules/stock";
// import offlineExporting from "highcharts/modules/offline-exporting";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import lineChart from "../commonCharts/lineChart.vue";
import Loader from "../Components/Loader.vue";

// stockInit(Highcharts);
// exportingInit(Highcharts);
// offlineExporting(Highcharts);

export default {
  name: "PriceFunFood",
  components: {
    Datepicker,
    Multiselect,
    Treeselect,
    lineChart,
    Loader,
  },
  data: function () {
    return {
      data: {},
      moment: moment,
      seriesDataFiltered: [],
      timestamp: moment().subtract(8, "days").format("YYYY-MM-DD"),
      timestamp2: moment().subtract(1, "days").format("YYYY-MM-DD"),
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      dateSingle: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      trendlineModalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      backuptrendLineModalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      timestamp2: moment().add(1, "days").format("YYYY-MM-DD"),
      timestamp1Disabled: {
        to: "",
        from: "",
      },
      timestamp2Disabled: {
        to: "",
        from: "",
      },
      catOptions: [],
      loader0: false,
      loader: false,
      // loader1: false,
      loaderPinList: false,
      trendLinePincodeLoader: false,
      trendLineGraphLoader: false,
      firstTimeTrendLineLoader: false,
      downloadExelLoader: false,
      tableloader: false,
      loader1: false,
      loader3: false,
      selectedCat: "",
      schKey: "",
      dataFull: {},
      chartData: [],
      selectedPlatform: "",
      platformColor: {
        // flipkart: "#2874f0",
        // amazon: "#83c42a",
        // amazon_retail: "#FF9900",
        // jiomart: "#FD5542",
        // bigbasket: "#666872",
        // blinkit: "rgb(248, 203, 70)",
      },
      platformForRR: {
        amazon_retail: "#83c42a",
        flipkart: "#2874f0",
        blinkit: "rgb(248, 203, 70)",
      },
      locationDropdown: {
        options: "",
        checkSelectedPins: [],
        selectedPin: "",
      },
      segmentDropdown: {
        options: "",
        selectedSegment: "",
      },
      isSegment: false,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      selectedExportButton: "20SKU",
      isDropdown: false,
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      refreshFilterState: "",
      storePriceTableData: {
        header: [
          { key: "product_image", value: "product Image" },
          { key: "product_name", value: "product Name" },
        ],
        data: [],
      },
      isSelectedSegment: true,
      showTrendLineModal: false,
      procedModalTrandLineData: { xAxis: [] },
      selectedProductTrendlineModal: "",
      selectedPlatformTrendlineModal: [],
      selectedSegmentTrendlineModal: "",
      storeSKUForTrendLineModal: "",
      viewModalTrendLineData: [],
      selectedPinTrendLineModal: "",
      allPlaformSelectedBoolean: true,
      storeAllPlatformsListForForMultiSelect: [],
      viewPinListModalTrendLine: [],
      competitorCheckBoxDataValue: false,
      selectedPlatformLastUpdate: "",
    };
  },
  // created() {
  //     window.addEventListener("click", this.close)
  // },

  // created() {
  //     window.addEventListener("click", this.close)
  // },
  // beforeDestroy() {
  //     window.removeEventListener("click", this.close)
  // },
  mounted() {
    this.dataAPIs();
  },

  watch: {
    showTrendLineModal(prevVal) {
      if (!prevVal) {
        this.allPlaformSelectedBoolean = true;
        this.trendlineModalDateRange.endDate =
          this.backuptrendLineModalDateRange.endDate;
        this.trendlineModalDateRange.startDate =
          this.backuptrendLineModalDateRange.startDate;
        this.selectedPinTrendLineModal = "";
      }
    },
  },
  // beforeDestroy() {
  //     window.removeEventListener("click", this.close)
  // },
  methods: {
    dataAPIs() {
      this.getLastUpdatedDates();
    },
    getLastUpdatedDates() {
      this.loader = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http.get(url).then(
        (response) => {
          // console.log(response.body.data.data.price_tracking, 'ssss')
          if (response.body.data.price_tracking) {
            localStorage.price_tracking_last_update = JSON.stringify(
              response.body.data.price_tracking
            );
            this.setDateRangeLastUpdated();
          }
          this.loader = false;
          // this.refresh()
          // console.log(this.dateRange.startDate, this.dateRange.endDate)

          this.getSegmentListData(); // for category and platform data
          this.getPinListData(true); // for pincode data
        },
        (err) => {
          this.loader = false;
          // this.refresh()
          console.log("err");
        }
      );
    },
    changePlatform() {
      // this.getPinListData();
      // this.getLastUpdatedDates();
      this.setDateRangeLastUpdated();
      this.getPinListData(false);
      this.getSegmentListData()
    },
    // handlePlatformSelection() {
    //   const platformEntry = Object.entries(this.platformColor).find(
    //     ([key, value]) => key === this.selectedPlatform
    //   );
    //   if (platformEntry) {
    //     const [platformName, platformColor] = platformEntry;
    //     this.selectedPlatformLastUpdate = { platformName, platformColor };
    //   }
    // },


    setDateRangeLastUpdated() {
      let priceTrackingDate;
      priceTrackingDate = JSON.parse(localStorage.price_tracking_last_update);
      if (this.selectedPlatform) {

        this.dateRange.endDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateRange.startDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).subtract(1, "week").format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.dateSingle.endDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateSingle.startDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.endDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.startDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).subtract(1, "week").format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.endDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.startDate = priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).subtract(1, "week").format("YYYY-MM-DD") : moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.maxDate = priceTrackingDate[this.selectedPlatform] ? new Date(priceTrackingDate[this.selectedPlatform].end_date) : new Date(priceTrackingDate.end_date);
        this.minDate = priceTrackingDate[this.selectedPlatform] ? new Date(priceTrackingDate[this.selectedPlatform].start_date) : new Date(priceTrackingDate.start_date);
      } else {

        this.dateRange.endDate = moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateRange.startDate = moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.dateSingle.endDate = moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateSingle.startDate = moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.endDate = moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.startDate = moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.endDate = moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.startDate = moment(priceTrackingDate.end_date).subtract(1, "week").format("YYYY-MM-DD");

        this.maxDate = new Date(priceTrackingDate.end_date);
        this.minDate = new Date(priceTrackingDate.start_date);
      }


      // this.dateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.dateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.dateSingle.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.dateSingle.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.trendlineModalDateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.trendlineModalDateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.backuptrendLineModalDateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.backuptrendLineModalDateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.maxDate = new Date(response.body.data.price_tracking.end_date);
      // this.minDate = new Date(
      //   response.body.data.price_tracking.start_date
      // );
      // this.handlePlatformSelection();
      this.selectedPlatform
        ? (this.lastUpdated = `${priceTrackingDate[this.selectedPlatform] ? moment(priceTrackingDate[this.selectedPlatform].end_date).format("DD MMM, YYYY") : moment(priceTrackingDate.end_date).format("DD MMM, YYYY")} 
        ${priceTrackingDate[this.selectedPlatform] ? priceTrackingDate[this.selectedPlatform].latest_time ? "at" : "" : priceTrackingDate.latest_time ? "at" : ""} 
        ${priceTrackingDate[this.selectedPlatform] ? priceTrackingDate[this.selectedPlatform].latest_time : priceTrackingDate.latest_time}`)
        : (this.lastUpdated = `${moment(priceTrackingDate.end_date).format("DD MMM, YYYY")} ${priceTrackingDate.latest_time ? "at" : ""
          } ${priceTrackingDate.latest_time}`);
      this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
    },
    // },
    // refresh(filterState = "") {
    //     this.refreshFilterState = filterState;
    //     this.getSegmentListData(filterState);
    // },

    // toggleDropdown() {
    //     if (this.isDropdown) {
    //         this.isDropdown = false
    //     }
    //     else {
    //         this.isDropdown = true
    //     }
    // },

    // close(event) {
    //     if (event.target) {
    //         if (event.target == this.$refs.clrBtn) { return; }
    //         else this.isDropdown = false

    //     }
    // },

    checkPriceDiff(value) {
      if (value > 0) {
        return "up";
      } else if (value < 0) {
        return "down";
      }
    },

    toggleCompetitorCheckBoxDataValue() {
      this.competitorCheckBoxDataValue = !this.competitorCheckBoxDataValue;
      this.getTableData();
    },

    downloadStandardExel() {
      let self = this;
      // this.loader1 = true;
      self.downloadExelLoader = true;
      // this.dataFull = {};
      let payload = {
        // start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        pincodes: self.locationDropdown.checkSelectedPins,
        platform: self.selectedPlatform,
        category: self.segmentDropdown.selectedSegment,
        // client: self.client,
        // pincode: this.locationDropdown.selectedPin,
      };

      // if (this.isSegment) {
      //   payload.segment =
      //     this.segmentDropdown.selectedSegment == ""
      //       ? ""
      //       : this.segmentDropdown.selectedSegment;
      // }
      const url = "/api/v2/indian_clients/pincode/price_tracking_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          // this.refresh();
          self.downloadExelLoader = false;
        },
        (err) => {
          self.downloadExelLoader = false;
          console.log("err");
        }
      );
    },

    // downloadExel() {
    //     let self = this;
    //     this.loader = true;
    //     let payload = {
    //         start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
    //         end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
    //         client: this.client,
    //         segment: [],
    //         pincode: []
    //     };
    //     if (this.isSegment) {
    //         payload.segment = []
    //     }
    //     const url = "/api/india_clients/pincode_price_report";
    //     self.$http.post(url, payload).then(
    //         (response) => {
    //             window.location = response.body.data;
    //             this.isDropdown = false
    //             self.loader = false;
    //         },
    //         (err) => {
    //             self.loader = false;
    //             console.log("err");
    //         }
    //     );
    // },
    // getting the List of All Platforms
    getAllPlatformsList() {
      let storeAllPlatforms = [];
      Object.keys(this.platformColor).forEach((platform) => {
        storeAllPlatforms.push(platform);
      });

      this.storeAllPlatformsListForForMultiSelect = storeAllPlatforms;
    },

    setLastUpdatedForTrendline() {
      let storeLastUpdated = JSON.parse(localStorage.price_tracking_last_update);
      if (this.selectedPlatformTrendlineModal.length == 1) {
        this.trendlineModalDateRange.endDate = storeLastUpdated[this.selectedPlatformTrendlineModal[0]] ? moment(storeLastUpdated[this.selectedPlatformTrendlineModal[0]].end_date).format("YYYY-MM-DD") : moment(storeLastUpdated.end_date).format("YYYY-MM-DD");
        this.trendlineModalDateRange.startDate = storeLastUpdated[this.selectedPlatformTrendlineModal[0]] ? moment(storeLastUpdated[this.selectedPlatformTrendlineModal[0]].end_date).subtract(1, "week").format("YYYY-MM-DD") : moment(storeLastUpdated.end_date).subtract(1, "week").format("YYYY-MM-DD");
      } else {
        this.trendlineModalDateRange.endDate = moment(storeLastUpdated.end_date).format("YYYY-MM-DD");
        this.trendlineModalDateRange.startDate = moment(storeLastUpdated.end_date).subtract(1, "week").format("YYYY-MM-DD");
      }
    },

    changeSelectInput() {
      console.log('correct')
      let length = 0;
      this.storeAllPlatformsListForForMultiSelect.forEach((items) => {
        length += 1;
      });

      if (length === this.selectedPlatformTrendlineModal.length) {
        this.allPlaformSelectedBoolean = true;
      } else {
        this.allPlaformSelectedBoolean = false;
      }

      // this.getPinListData(false)
      this.getPinListForModalTrendLine(false);
      // console.log('change platform', )
      this.setLastUpdatedForTrendline();

    },

    setAllPlatformsFun() {
      // console.log('changes other platform')
      this.selectedPlatformTrendlineModal = [];
      this.storeAllPlatformsListForForMultiSelect.forEach((items) => {
        this.selectedPlatformTrendlineModal = [
          ...this.selectedPlatformTrendlineModal,
          items,
        ];
      });
      this.getPinListForModalTrendLine(true);
      // console.log('nhi')
    },

    selectPlatformsForAllList() {
      this.allPlaformSelectedBoolean = !this.allPlaformSelectedBoolean;
      this.selectedPlatformTrendlineModal = [];
      if (this.allPlaformSelectedBoolean) {
        this.storeAllPlatformsListForForMultiSelect.forEach((items) => {
          this.selectedPlatformTrendlineModal = [
            ...this.selectedPlatformTrendlineModal,
            items,
          ];
        });
      }
      // console.log('ok for all')
      this.getPinListForModalTrendLine(false);
      this.setLastUpdatedForTrendline();
      // this.PINList.forEach(PINGroup => {
      //         this.selectedPIN = [...this.selectedPIN, ...PINGroup.pincodes];
      //     })

      // if(this.allPlaformSelectedBoolean){
      //     this.selectedPlatformTrendlineModal = storeAllPlatformsListForForMultiSelect
      // }else{
      //     this.selectedPlatformTrendlineModal = []
      // }

      // console.log('new')
    },

    // downloadLastExel() {
    //     let self = this;
    //     this.loader = true;
    //     let endData = moment().subtract(1, 'days').format("YYYY-MM-DD")
    //     let payload = {
    //         start_date: moment(endData).subtract(2, 'months').format("YYYY-MM-DD"),
    //         end_date: endData,
    //         client: this.client,
    //         segment: [],
    //         pincode: []
    //     };
    //     if (this.isSegment) {
    //         payload.segment = []
    //     }
    //     const url = "/api/india_client/pincode_month_report";
    //     self.$http.post(url, payload).then(
    //         (response) => {
    //             window.location = response.body.data;
    //             this.isDropdown = false
    //             self.loader = false;
    //         },
    //         (err) => {
    //             self.loader = false;
    //             console.log("err");
    //         }
    //     );
    // },

    getSegmentListData() {
      let self = this;
      this.loader0 = true;
      let payload = {
        client: this.client,
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
      };
      // console.log(this.dateRange.endDate, 'ddd');
      const url = "/api/v2/india_clients/pincode_category";
      self.$http.post(url, payload).then(
        (response) => {
          self.segmentDropdown.options = response.data.data.data;
          if (self.isSelectedSegment) {
            self.segmentDropdown.selectedSegment = "";
          }
          self.isSegment = response.data.data.is_segment;
          this.platformColor = response.data.data.platforms;
          this.getAllPlatformsList(); // getting all platforms for TrendLine
          self.loader0 = false;
        },
        (err) => {
          self.loader0 = false;
          console.log("err");
        }
      );
    },

    getPinListData(flag) {
      let self = this;
      self.loaderPinList = true;

      let payload = {
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        client: this.client,
        // platform: self.selectedPlatform,
      };

      if (self.selectedPlatform == "") {
        payload.platform = [];
      } else {
        payload.platform = [];
        payload.platform.push(self.selectedPlatform);
      }

      // const url = "/api/india_client/pincode_list";
      const url = "/api/v2/india_client/pincode_list";
      self.$http
        .post(url, payload)
        .then((response) => {
          // window.location = response.body.data;
          this.locationDropdown.options = response.data.data;
          if (this.locationDropdown.options.length) {
            this.locationDropdown.checkSelectedPins = [];
            this.locationDropdown.checkSelectedPins.push(
              this.locationDropdown.options[0].children[0].children[0].id
            );
          }
          if (flag) {
            this.getTableData(); // for table data;
          }

          // this.getLastUpdatedDates()
          self.loaderPinList = false;
          // this.getPriceData();
        })
        .catch((err) => {
          self.loaderPinList = false;
          console.log("err");
        });
    },
    // updateDisabledDates() {
    //     this.timestamp1Disabled = {
    //         to: moment("2022-09-10", "YYYY-MM-DD").toDate(),
    //         from: moment(this.timestamp2, "YYYY-MM-DD").toDate(),
    //     };
    //     this.timestamp2Disabled = {
    //         to: moment(this.timestamp, "YYYY-MM-DD").toDate(),
    //         from: moment().subtract(1, "day").toDate(),
    //     };
    // },

    getPinListForModalTrendLine(flag) {
      let self = this;
      this.trendLinePincodeLoader = true;
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        client: this.client,
        platform: self.selectedPlatformTrendlineModal,
      };

      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListModalTrendLine = response.data.data;
          if (this.viewPinListModalTrendLine.length) {
            this.selectedPinTrendLineModal = "";
            this.selectedPinTrendLineModal =
              this.viewPinListModalTrendLine[0].children[0].children[0].id;
          }
          if (flag) {
            this.getModalTrendlineGraphData(true, false);
          }

          self.trendLinePincodeLoader = false;
        },
        (err) => {
          self.trendLinePincodeLoader = false;
          console.log("err");
        }
      );
    },

    // processSelectedPin() {
    //     if (this.locationDropdown.checkSelectedPins) {
    //         this.locationDropdown.selectedPin = this.locationDropdown.checkSelectedPins.map(
    //             (obj) => obj.pin
    //         );
    //         this.getPriceData();
    //     }
    // },

    formatNumber(n) {
      if (n && !isNaN(n)) {
        return Number(n).toLocaleString();
      } else {
        return n;
      }
    },

    processProductModalTrendlineGraph() {
      this.procedModalTrandLineData = {};

      let seriesData = [];
      let xAxisData = [];
      this.viewModalTrendLineData.forEach((items) => {
        xAxisData.push(moment(items.date).format("DD MMM"));
        const processedSeries = new Set();

        items.price.forEach((data) => {
          const processedName = data.name.replace(/_/g, " ");
          if (!processedSeries.has(processedName)) {
            let series = seriesData.find(s => s.name === processedName);

            if (!series) {
              series = {
                name: processedName,
                color: this.getColorForKey(processedName), // Assign color dynamically
                tooltip: { valuePrefix: "₹" }, // Adjust tooltip prefix
                marker: {
                  enabled: true,
                  lineWidth: 3,
                  fillColor: "#fff",
                  lineColor: this.getColorForKey(processedName),
                  radius: 4,
                  // states: {
                  //   hover: {
                  //     radiusPlus: 4.1,
                  //     lineWidthPlus: 3.1,
                  //   },
                  // },
                  symbol: "circle",
                },
                dataLabels: {
                  enabled: false,
                  allowOverlap: true,
                  style: { fontWeight: "normal" },
                  formatter: function () {
                    return "₹" + this.point.y.toLocaleString();
                  },
                },
                data: [], // Initialize empty array to store data points
              };
              seriesData.push(series); // Add the new series to seriesData array
            }
            series.data.push(data.value);
            processedSeries.add(processedName);
          }
        });
      });

      this.procedModalTrandLineData = {
        id: "modalTrendLineGraph",
        xAxis: xAxisData,
        seriesData: seriesData,
        yAxisTitle: "Price(₹)",
      };
      // this.procedModalTrandLineData.id = "modalTrendLineGraph"
      // this.procedModalTrandLineData.series = seriesData;
      // this.procedModalTrandLineData.xAxis = xAxisData;
      // this.procedModalTrandLineData.yAxisTitle = "Price"
    },

    getColorForKey(key) {
      let updateKey = key.toLowerCase().replace(' ', '_');
      return this.platformColor[updateKey] || '#333';
    },

    processTrendLineModal(segment, productName, sku, pinCode) {
      // console.log(platform, segment, productName)
      // console.log(typeof pinCode)
      this.showTrendLineModal = true;
      this.procedModalTrandLineData = { xAxis: [] };
      this.selectedPlatformTrendlineModal = [];
      this.selectedSegmentTrendlineModal = "";
      this.selectedProductTrendlineModal = productName;
      //   this.selectedSegmentTrendlineModal = segment;
      this.storeSKUForTrendLineModal = sku;
      this.selectedPinTrendLineModal = "";
      this.getPinListForModalTrendLine(true);
      // this.selectPlatformsForAllList();
      this.selectedPinTrendLineModal = String(pinCode);
      this.setAllPlatformsFun();
      this.getModalTrendlineGraphData(true, false);
    },

    getModalTrendlineGraphData(getLoaderValue1, getLoaderValue2) {
      let self = this;
      self.trendLineGraphLoader = getLoaderValue2;
      self.firstTimeTrendLineLoader = getLoaderValue1;
      self.viewModalTrendLineData = [];
      let url = "/api/v2/indian_clients/price_tracking/product";

      let payload = {
        // client: self.client,
        start_date: moment(this.trendlineModalDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        sku: self.storeSKUForTrendLineModal,
        pincode: self.selectedPinTrendLineModal,
        platforms: self.selectedPlatformTrendlineModal,
        category: self.selectedSegmentTrendlineModal,
      };

      // let headers = {
      //   Token:
      //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMmIzYjAwMGI1YTk4NGU4ZWFjMjNjMjBjZDY1MWE0NzciLCJjbGllbnRfaWQiOiIxZTViMTFkNzFiZjg0ZWU3YWM1ODRkYjI3ZDQ1ODM4OSIsInRhcmdldF90aW1lIjoiMjAyNi0wOS0xMSAxNDo0ODowNC42MDExMzIiLCJhZG1pbiI6dHJ1ZX0.8_GtpOxfTBVpodGJKyJJ7PfjmG4msJNxcwbbyl9Xnpc",
      // };
      self.$http
        .post(url, payload)
        .then((res) => {
          this.viewModalTrendLineData = res.data.data;
          this.processProductModalTrendlineGraph();
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        })
        .catch((err) => {
          this.$bvToast.toast(`${err.data.summary}`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        });
    },

    filterApply() {
      this.getTableData();
    },

    filterApplyForTrendLine() {
      this.getModalTrendlineGraphData(false, true);
    },
    dataTable() {
      let self = this;
      $("#price-tracking-table").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },
        autoWidth: false,
        ordering: false,
        pagingType: "full_numbers",
        searching: true,
        autoWidth: false,
      });
      let search = require("../../../public/Icons_SVG/Search.svg");
      $("#price-tracking-table" + "_filter > label").append(
        `<div><img src='${search}' /></div>`
      );

      $("#price-tracking-table").wrap(
        "<div style='overflow:auto; width:100%;position:relative;'></div>"
      );

      // var compareBtn = $('<input type="button" class="btn compareBtn" value="Compare" id="compareBtn"/>');
      // $("#price-tracking-table_filter > label").append(compareBtn);

      var btn = $(
        '<input type="button" class="btn exportBtn" value="Export" id="exportBtn"/>'
      );
      $("#price-tracking-table_filter > label").append(btn);

      $("#exportBtn").click(() => {
        self.downloadStandardExel();
      });

      // $("#compareBtn").click(() => {
      //     self.$router.push("/price-tracking-compare");
      // })
    },

    getTableData() {
      let self = this;
      self.tableloader = true;
      $("#price-tracking-table").DataTable().destroy();
      this.storePriceTableData.data = [];
      let payload = {
        // client: self.client,
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        pincodes: self.locationDropdown.checkSelectedPins,
        platform: self.selectedPlatform,
        category: self.segmentDropdown.selectedSegment,
        allow_competitor: self.competitorCheckBoxDataValue,
      };

      // if (self.isSegment) {
      //     payload.category = self.segmentDropdown.selectedSegment == "" ? "" : self.segmentDropdown.selectedSegment
      // }
      const url = "/api/v2/indian_clients/price_tracking/table";
      let headers = {
        Token:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMmIzYjAwMGI1YTk4NGU4ZWFjMjNjMjBjZDY1MWE0NzciLCJjbGllbnRfaWQiOiIxZTViMTFkNzFiZjg0ZWU3YWM1ODRkYjI3ZDQ1ODM4OSIsInRhcmdldF90aW1lIjoiMjAyNi0wOS0xMSAxNDo0ODowNC42MDExMzIiLCJhZG1pbiI6dHJ1ZX0.8_GtpOxfTBVpodGJKyJJ7PfjmG4msJNxcwbbyl9Xnpc",
      };

      self.$http
        .post(url, payload)
        .then((res) => {
          // console.log(res.data.data)
          // self.storeAllPriceData = res.data.data;
          const resData = res.data.data;
          const modifiedTableData = resData.data;
          const headerData = resData.headers;
          this.storePriceTableData.header = [];
          this.storePriceTableData.data = modifiedTableData;
          this.storePriceTableData.header = headerData;
          this.$nextTick(() => {
            this.dataTable();
          });
          self.tableloader = false;
        })
        .catch((err) => {
          self.tableloader = false;
          console.log(err);
        });

      // self.loader = false
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 5px 10px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
  height: 35px;
  display: flex;
  align-items: center;
}

.CustomDropdown {
  border: 1px solid rgb(172, 172, 172);
  z-index: 999999999 !important;
  margin-left: 5px;
  border-radius: 3px;
  margin-top: 2px;
  position: absolute;
  background: white;
  width: 200px;
  right: 12px;
}

.customItem {
  padding: 3px 5px 2px 8px;
  cursor: pointer;
  color: var(--primary_brand);
}

.customItem:hover {
  background: var(--primary_brand-10);
}

.chartOverflow {
  overflow-x: scroll;
}

.name {
  line-height: 28px;
  text-transform: capitalize;
  font-size: 14px;
  margin-left: 5px;
}

.value {
  font-size: 14px;
  line-height: 24px;
  margin-right: 5px;
}

.leftsticker {
  width: 65px;
  float: left;
  height: 54px;
  color: white;
  font-size: 37px;
  text-align: center;
}

.rightsticker {
  width: 100%;
  /* float: left; */
  background: white;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.card {
  margin-bottom: 8px;
}

.card-body {
  padding: 0 !important;
  display: flex;
}

.productwrap {
  padding: 26px;
  padding-top: 6px;
  margin-top: 6px;
}

.swiggy_border {
  border-right: 2px solid #f5670e;
}

.zepto_border {
  border-right: 2px solid #d5b3ff;
}

.grofers_border {
  border-right: 2px solid #f15c2c !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.bigbasket_border {
  border-right: 2px solid #666872 !important;
}

.blinkit_border {
  border-right: 2px solid rgb(248, 203, 70) !important;
}

.jiomart_border {
  border-right: 2px solid #fd5542 !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.amazon_border {
  border-right: 2px solid #83c42a !important;
}

.amazon_retail_border {
  border-right: 2px solid #ff9900 !important;
}

.croma_border {
  border-right: 2px solid #49a7a1 !important;
}

.paytm_border {
  border-right: 2px solid #28bbf0 !important;
}

.snapdeal_border {
  border-right: 2px solid #f34741 !important;
}

.myntra_border {
  border-right: 2px solid #ec548b !important;
}

.vijaysales_border {
  border-right: 2px solid #ee4326 !important;
}

.ril_border {
  border-right: 2px solid #bfa161 !important;
}

.outofstock {
  color: red;
  float: right;
  font-size: 12px;
  margin-right: 5px;
  text-transform: capitalize;
}

.instock {
  color: var(--green);
  float: right;
  font-size: 12px;
  margin-right: 5px;
  text-transform: capitalize;
}

.flipkart_border,
.flipkart_grocery_border {
  border-right: 2px solid #2874f0 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect {
  margin-inline: 0.5rem;
}

.customSelectExport {
  margin-inline: 0.5rem;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 20px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.insights {
  background-color: #fab937;
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 20px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.insights:hover {
  background-color: #fac04c !important;
  color: white !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

#sovindia4page {
  font-family: "Poppins", sans-serif !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 7px 0px !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.productListCheckbox span {
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}
</style>
<style>
.vue-treeselect__control {
  height: 35px !important;
  border: 1px solid rgba(75, 75, 75, 0.4) !important;
  border-radius: 5px !important;
}

.vue-treeselect__multi-value {
  height: 30px !important;
  overflow: auto !important;
}

.vue-treeselect__multi-value-item {
  background-color: rgba(6, 85, 89, 1) !important;
  color: white !important;
}

.vue-treeselect__value-remove {
  color: white !important;
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselect .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin: 10px;
  margin-bottom: 1rem;
}

/* datatable */
#price-tracking-table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#price-tracking-table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#price-tracking-table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#price-tracking-table_wrapper #price-tracking-table.table.dataTable th {
  background: rgba(39, 86, 89, 0.1) !important;
  background-color: none !important;
  color: #5e5e5e !important;
  font-weight: 600 !important;
  font-family: "Poppins" !important;
  font-size: 14px !important;

}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc {
  background-image: none !important;
}

table.dataTable thead>tr>th.sorting_asc:before,
table.dataTable thead>tr>th.sorting_asc:after {
  display: none !important;
}

#price-tracking-table_wrapper #price-tracking-table.table.dataTable td {
  font-family: "Heebo" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #5e5e5e !important;
}

#price thead {
  background: none !important;
}

.thead-normal {
  background: none !important;
}

#price-tracking-table_info {
  position: relative;
  top: 9px;
  /* left: 54%; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#price-tracking-table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

/* .dataTables_paginate .page-link {
    border: none !important;
    background: none !important;
    color: var(--primary_brand-80) !important;
} */

#price-tracking-table_filter .exportBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#price-tracking-table_filter .exportBtn:hover {
  background: var(--primary_brand-80);
}

.compareBtn {
  margin: 0px 0 0 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: white;
  border: 1px solid var(--primary_brand);
  color: var(--primary_brand);
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

.compareBtn:hover {
  background: var(--primary_brand);
  color: #fff;
}

.dataTables_empty {
  color: #ff00009e !important;
}

.outOfStockColor {
  color: #c00000;
}

.noData {
  background: #fff7f7 !important;
}

.showTrandLine {
  cursor: pointer;
}

/* modal for trendLine */
.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  font-family: "poppins";
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

#trendLineModal .modal-header {
  text-transform: capitalize;
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

#modalContainer .vue-treeselect__input-container>input:focus {
  box-shadow: none;
}

#modalContainer .vue-treeselect--single .vue-treeselect__option--selected {
  background: #44777a1a !important;
  font-weight: 600;
}

button[disabled="disabled"] {
  cursor: not-allowed !important;
}

.imageContainerPriceTracking {
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0.05) 0%,
      rgba(255, 255, 255, 0) 100%) !important;
}

.customSelectedLabels .custom-tag {
  background: var(--primary_brand-80) !important;
  padding: 1px 0px 1px 10px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-block !important;
  align-items: center !important;
  color: #fff !important;
}

.customSelectedLabels .custom-tag .remove-icon:hover {
  background-color: #369a6e;
  border-radius: 5px;
}

.customSelectedLabels .remove-icon {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
  color: #fff;
  font-weight: bold;
}

.highcharts-tooltip text {
    text-transform: capitalize !important;
}

.competitorCheckBox input[type="checkbox"]:checked {
  background-color: var(--primary_brand) !important;
  accent-color: var(--primary_brand) !important;
}

.competitorCheckBox input[type="checkbox"] {
  cursor: pointer !important;
}

.containerOverflowClass {
  width: 99.7% !important;
  overflow-x: visible !important;
}

@media screen and (max-width: 767px) {
  #price-tracking-table_paginate {
    float: none;
    width: auto;
  }
}

@media screen and (max-width: 1280px) {
  table.dataTable td {
    font-size: 13px !important;
  }
}

@media (min-width: 1034px) {
  .customWidth-70 {
    width: 70%;
  }
}
</style>
